module.exports = __webpack_public_path__ + "06e1291a49bb638b48cfdb0a311b79e1.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_r_40.mp3
// module id = 435
// module chunks = 0